import { useAuthContext } from '@providers/AuthProvider';

export const AdminCard = () => {
  const { me } = useAuthContext();
  return (
    <div className="px-[11px]">
      <div className="font-medium text-sm leading-[130%] tracking-[0.02em] text-title w-[200px]">
        Welcome to the Admin Panel!
      </div>
      <div className="font-normal text-xs leading-[110%] text-foreground-muted text-ellipsis overflow-hidden pt-[7px]">
        {me?.email}
      </div>
    </div>
  );
};
